import { CrudEndpoint } from './crud.endpoint';

export class ReviewCampaignsEndpoint extends CrudEndpoint {
	constructor() {
		super('review-campaigns');
	}
}
